/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import App from '../../App';
import config from '../../config/config';
import LoadingBackdrop from '../../features/backdrops/loading-backdrop/LoadingBackdrop';
import ErrorMessage from '../../features/error/ErrorMessage';

/**
 * Create VST user on the fly with login api and create_user flag
 */
export default function VstWebsocketConnection() {
  const [socket, setSocket] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [message, setMessage] = useState('');
  const [connected, setConnected] = useState(false);
  
  useEffect(() => {
    if (retryCount < 5) {
      // Create a new WebSocket instance
      const newSocket = new WebSocket(
        `${config.vstWebsocketEndpoint}?connectionId=${window.tokkioPeerId}`
      );

      // Set up the event handlers
      newSocket.onopen = () => {
        console.log('WebSocket connected');
        setConnected(true);
        setRetryCount(0);
      };

      newSocket.onerror = () => {
        console.log('WebSocket error');
        // Increment the retry count
        setRetryCount((rc) => rc + 1);
        setConnected(false);
      };

      newSocket.onmessage = (event) => {
        console.log(`WebSocket message received: ${event.data}`);
        setMessage(event.data);
      };

      // Save the new socket instance in state
      setSocket(newSocket);
    }
  }, [retryCount]);

  if(socket)
  console.log("socket.readyState: ", socket.readyState)

  return (
    <div>
      {socket && connected && (
        <App
          receivedWebsocketMessage={message}
        />
      )}
      {retryCount < 5 && !(socket && connected) && (
        <LoadingBackdrop />
      )}
      {retryCount >= 5 && <ErrorMessage status="vst-websocket-error" />}
    </div>
  );
}
